module.exports = __webpack_public_path__ + "img/camping.8d6a8c9c.png";